<template>
<div class="shops">
    <div id="map"></div>
    <div class="current-locate" @click="locateUser">
        <img src="../assets/zoom-in-orange.svg" alt v-if="showLocateMarker" />
        <img src="../assets/zoom-in.svg" alt v-else />
    </div>
    <div class="current-marker" ref="marker">
        <div class="circle">
            <div class="arrow"></div>
        </div>
    </div>
    <div class="popup" ref="popup" @click="handleDetail">
        <div class="img-container">
            <img v-if="popupDetail.images && popupDetail.images.length > 0"
                    v-lazy="generateObj(popupDetail.images[0].image)"/>
            <img v-else-if="popupDetail.image" v-lazy="generateObj(popupDetail.image)"/>
            <img v-else v-lazy="generateObj(popupDetail.image_url)"/>
        </div>
        <div class="popup-detail">
            <div class="popup-name">{{ popupDetail.name }}</div>
            <div class="distance">{{ popupDetail.city }}{{ popupDetail.address ? ' | ' : '' }}{{ popupDetail.address }}&nbsp;&nbsp;&nbsp;&nbsp;{{ popupDetail.distance ? '距离' + popupDetail.distance : '' }}</div>
            <div class="count">{{ popupDetail.mall_count }}家店</div>
        </div>
        <div class="popup-btns">
            <div class="navigate-icon" @click.stop="handleNavigate">
                <img src="/image/map-navigate.png"/>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import { getShopList } from '@/fetch/api'
import { pointWithinThere, GetDistance } from '@/utils/index'

export default {
    data () {
        return {
            sites: [],
            startGeo: {},
            showLocateMarker: false,
            popupDetail: {},
            isUserAllowedGeoLocation: false,
            inThere: false,
        }
    },
    created () {
        window.navigator.geolocation.getCurrentPosition((res) => {
            this.isUserAllowedGeoLocation = true
            const longitude = res.coords.longitude
            const latitude = res.coords.latitude
            // console.log(longitude, latitude)
            if (longitude) {
                const inThere = pointWithinThere(longitude, latitude)
                this.inThere = inThere
                this.startGeo = {
                    lon: longitude,
                    lat: latitude
                }
                if (this.sites.length > 0) {
                    this.sites = this.sites.map(item => {
                        item.distance = GetDistance(latitude, longitude, item.lat, item.lon)
                        return item
                    })
                }
            }
        }, err => {
            this.isUserAllowedGeoLocation = false
            this.inThere = false
            this.startGeo = {
                lon: -98.230711,
                lat: 39.446860
            }
            if (this.sites.length > 0) {
                this.sites = this.sites.map(item => {
                    item.distance = GetDistance(39.446860, -98.230711, item.lat, item.lon)
                    return item
                })
            }
      }, { timeout: 10000, enableHighAccuracy: true })
    },
    mounted () {
        mapboxgl.accessToken = "pk.eyJ1IjoicHVzaGlhbiIsImEiOiJjaXdyaXptNDAweG1rMm90YmRnZHl0dDFpIn0.9kBN2eXNRe3uZ9VMoMhfhg";
        let center = [-98.230711, 39.446860]
        let zoom = 5
        this.map = new mapboxgl.Map({
            container: "map",
            style: "mapbox://styles/pushian/cj8313byya3lp2so6gvh49efn",
            center,
            zoom
        // bounds: new mapboxgl.LngLatBounds([103.852152, 1.260704], [103.804682, 1.267034])
        })

        // Add geolocate control to the map.
        this.geoControl = new mapboxgl.GeolocateControl({
            trackUserLocation: true
        })

        this.map.on("load", () => {
            this.getShops()
        })

        // 根据zoom设置透明度
        this.map.on("zoom", () => {
            this.changeOpacity()
        })
    },
    methods: {
        generateObj (src) {
            return {
                src,
                error: '/image/default-simon.jpg',
                loading: '/image/loading-img.jpg'
            }
        },
        calcData (zoom) {
            const minSize = 0.36
            const maxSize = 0.5
            const rate = 0.08
            let opacity = zoom * 0.1 - 0.5
            let size = zoom * rate - 0.1

            if (size < minSize) {
                size = minSize
            } else if (size > maxSize) {
                size = maxSize
            }
            if (opacity > 1) {
                opacity = 1
            } else if (opacity < 0.7) {
                opacity = 0.7
            }
            return {
                opacity,
                size
            }
        },
        // 修改layer opactiy
        changeOpacity () {
            const zoom = this.map.getZoom()
            console.log(zoom)
            const data = this.calcData(zoom)

            this.map.setPaintProperty('sites', 'icon-opacity', data.opacity)
            this.map.setLayoutProperty('sites', 'icon-size', data.size)
        },
        // 获取所有商场
        getShops () {
            getShopList({ site_id: 1 }).then(res => {
                const sites = res.sites.map(item => {
                    item.mall_count = Math.round(Math.random() * 100) + 100
                    if (this.startGeo.lon) {
                        item.distance = GetDistance(this.startGeo.lat, this.startGeo.lon, item.lat, item.lon)
                    }
                    return item
                })
                this.sites = sites
                this.map.loadImage('/image/map/SiteShop.png', (error, image) => {
                    console.log(error, image)
                    if (!error) {
                        this.map.addImage('shop', image)
                        const features = sites.map((item, index) => {
                            return {
                                type: 'Feature',
                                properties: {
                                    siteIndex: index,
                                    icon: 'shop'
                                },
                                geometry: {
                                    type: 'Point',
                                    coordinates: [item.lon, item.lat]
                                }
                            }
                        })

                        this.map.addLayer({
                            id: 'sites',
                            type: 'symbol',
                            source: {
                                type: 'geojson',
                                data: {
                                    type: 'FeatureCollection',
                                    features: features
                                }
                            },
                            layout: {
                                'icon-image': 'shop',
                                'icon-size': 0.34
                            }
                        })
                        if (this.$route.query.shopId) {
                            const site = sites.find(item => item.id === parseInt(this.$route.query.shopId))
                            this.popupDetail = site
                            this.$nextTick(() => {
                                this.initPopup({
                                    geometry: {
                                        coordinates: [site.lon, site.lat]
                                    }
                                }, { lon: site.lon, lat: site.lat })
                            })
                        } else {
                            const bounds = this.calcLonLat(sites)
                            this.map.fitBounds(bounds, {
                                padding: {
                                    top: 60,
                                    bottom: 60,
                                    left: 60,
                                    right: 60
                                }
                            })
                        }

                        this.map.on('click', 'sites', e => {
                            const feature = e.features[0]
                            const lngLat = e.lngLat
                            const siteIndex = parseInt(feature.properties.siteIndex)
                            const currentSite = sites[siteIndex]
                            this.popupDetail = currentSite
                            this.$nextTick(() => {
                                this.initPopup(feature, lngLat)
                            })
                        })
                    }
                })
            })
        },
        // 计算[sw, ne]
        calcLonLat (array) {
            let minLon = array[0].lon
            let minLat = array[0].lat
            let maxLon = array[0].lon
            let maxLat = array[0].lat
            array.forEach(item => {
                if (item.lon < minLon) {
                    minLon = item.lon
                } else if (item.lon > maxLon) {
                    maxLon = item.lon
                }
                if (item.lat < minLat) {
                    minLat = item.lat
                } else if (item.lat > maxLat) {
                    maxLat = item.lat
                }
            })
            return [[minLon, minLat], [maxLon, maxLat]]
        },
        // init popup
        initPopup (feature, lngLat) {
            console.log('点击弹窗触发', feature)
            if (this.popup && this.popup.isOpen) {
                this.popup.remove()
            }
            const coordinates = feature.geometry.coordinates.slice()

            while (Math.abs(lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += lngLat.lng > coordinates[0] ? 360 : -360
            }

            this.popup = new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setDOMContent(this.$refs.popup)
                .addTo(this.map)

            this.map.flyTo({center: feature.geometry.coordinates})
        },
        // 点击按钮定位到当前位置
        locateUser() {
            if (!this.isUserAllowedGeoLocation) {
                this.$createDialog({
                    type: 'alert',
                    confirmBtn: {
                        text: this.$t('common.confirm')
                    },
                    content: this.$t('navigate.plzAllowLocation')
                }).show()
                return
            }
            if (!this.inThere) {
                let text = ''
                if (this.siteId === '245') {
                    text = '亲，你的当前位置不在RWS'
                } else if (this.siteId === '129') {
                    text = '亲，你的当前位置不在新加坡'
                } else if (this.siteId === '33') {
                    text = '亲，你的当前位置不在德国'
                } else {
                    text = '亲，你的当前位置不在圣淘沙'
                }
                this.toast = this.$createToast({
                    time: 1500,
                    type: 'txt',
                    txt: text
                })
                this.toast.show()
                return
            }
            if (this.startGeo && this.startGeo.lon) {
                if (!this.currentMarker) {
                    this.drawCurrentMarker(this.startGeo.lon, this.startGeo.lat)
                }
                this.map.panTo([this.startGeo.lon, this.startGeo.lat])
            } else {
                this.toast = this.$createToast({
                    time: 1500,
                    type: 'txt',
                    txt: '未获取到你的位置，请稍后重试！'
                })
                this.toast.show()
            }
        },
        // 添加当前位置marker
        drawCurrentMarker (longitude, latitude) {
            // add marker to map
            this.showLocateMarker = true
            const marker = new mapboxgl.Marker(this.$refs.marker)
                .setLngLat([longitude, latitude])
                .addTo(this.map)
            this.currentMarker = marker
        },
        handleDetail () {
            const name = this.popupDetail.name
            window.wx.miniProgram.postMessage({
                data: {
                    mall: name
                }
            })
            window.wx.miniProgram.navigateBack()
        },
        handleNavigate () {
            window.wx.miniProgram.navigateTo({
                url: `/pages/mallNav/index?name=${this.popupDetail.name}`
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.shops {
     #map {
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }

    .distance {
        margin: 5px 0;
        font-size: 12px;
        line-height: 17px;
        color: #888888;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .count {
        font-size: 12px;
        color: #888888;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>